import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const SettingsPage: React.FC = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Settings
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Configure application settings and preferences.
        </Typography>
        {/* Settings components will be added here */}
      </Box>
    </Container>
  );
};

export default SettingsPage;